export default __webpack_public_path__ + "static/media/step-1.cc3ecbc6.png";